'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcValueList
* @element List of Checkboxes (Listbox Value List)
* @description
* # tcValueList
* List of Checkboxes (Listbox Value List)
*/
angular.module('tcApp').directive('tcValueList', function() {
	return {
		restrict: 'E',
		scope: {
			valueListItemName: '@tcValueListItemName',
			valueListComponentForm: '=tcValueListComponentForm'
		},
		require: '^ngModel',
		link: function(scope, element, attrs, ngModel) {
			// Add the control to the form manually, so component dirty state can be updated when item state changes
			ngModel.$name = scope.valueListItemName;
			scope.valueListComponentForm.$addControl(ngModel);
		}
	};
});
